import { Component } from "@angular/core";
import { Todo } from "./todo";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  title = "project cc";
  todoValue: string;
  list: Todo[];

  ngOnInit() {
    this.list = [];
    this.todoValue = "";
    if (localStorage.getItem("todo").length > 0) {
      this.list = JSON.parse(localStorage.getItem("todo"));
    }
  }
  addItem() {
    if (this.todoValue !== "") {
      const newItem: Todo = {
        id: Date.now(),
        value: this.todoValue,
        isDone: false
      };
      this.list.push(newItem);
      localStorage.setItem("todo", JSON.stringify(this.list))
    }
    this.todoValue = "";
  }
  deleteItem(id: number) {
    this.list = this.list.filter(item => item.id !== id);
  }
}
